import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  Box,
  CardMedia,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { useParams } from "react-router-dom";
import Colors from "assets/Style/Colors";
import { ErrorToaster } from "components/Toaster";
import { PrimaryButton } from "components/Buttons";
import { CommaSeparator, handleExportWithComponent } from "utils";
import ExportServices from "services/Export";
import {
  FontFamily,
  Images,
  InvoiceGlobal,
  InvoiceLocation,
  InvoiceMail,
  InvoicePhone,
} from "assets";

import { makeStyles } from "@mui/styles";
import moment from "moment";
import { PDFExport } from "@progress/kendo-react-pdf";

const useStyle = makeStyles({
  headingBg: {
    margin: "32px 0px",
    padding: "12px 0px",
    textAlign: "center",
  },
  heading: {
    color: Colors.white,
    textTransform: "uppercase",
    fontWeight: 300,
    fontFamily: FontFamily.openSans,
  },
  text: {
    color: "rgba(0, 0, 0, 0.6)",
    fontWeight: 300,
    fontFamily: FontFamily.openSans,
    fontSize: 14
  },
  tableCell: {
    backgroundColor: Colors.aliceBlue,
    border: "0.5px solid rgba(0, 0, 0, 0.6)",
    "& .MuiTypography-root": {
      padding: "4px 12px",
    },
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
});


function ExportPaymentsRecipt() {
  const { id } = useParams();
  const contentRef = useRef(null);
  const classes = useStyle();

  const [loader, setLoader] = useState(false);
  const [checklist, setChecklist] = useState("");

  //*For Vehicle Data
  const [ExportVehicleDetails, setExportVehicleDetails] = useState();

  //*For Customer Details
  const [customerDetails, setCustomerDetails] = useState();

  // *For Customer Booking
  const [customers, setCustomers] = useState([]);

  // *For Pictures
  const [pictures, setPictures] = useState([]);
  const [imageIndex, setImageIndex] = useState(0);


  // *For Payment Receipt Detail
  const [paymentReceiptDetail, setPaymentReceiptDetail] = useState();
  const [totalAmount, setTotalAmount] = useState(0);


  // *For Get Payment Receipt Detail
  const getVehicleExportDetails = async () => {
    setLoader(true);
    try {
      let params = { payment_detail_id: id };
      const { data } = await ExportServices.getExportGroupPaymentsDetails(params);
      const rows = data?.funds?.rows || [];

      const total = rows.reduce((acc, curr) => acc + parseFloat(curr.amount || 0), 0);

      setTotalAmount(total);

      setExportVehicleDetails(data?.funds?.rows);
      setCustomerDetails(data?.funds?.rows?.[0]?.customer);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };


  useEffect(() => {
    if (id) {
      getVehicleExportDetails();

    }
  }, [id]);
  const isAed = ExportVehicleDetails?.[0]?.currency?.includes("AED")
  return (
    <Container>
      {!loader && (
        <Box sx={{ textAlign: "right", p: 4 }}>
          <PrimaryButton
            title="Download Receipt"
            type="button"
            style={{ backgroundColor: Colors.bluishCyan }}
            onClick={() => handleExportWithComponent(contentRef)}
          />
        </Box>
      )}

      <Box
        sx={{
          width: "1000px",
          mx: 4,
          my: 2,
          bgcolor: Colors.white,
          boxShadow: "0px 8px 18px 0px #9B9B9B1A",
        }}
      >
        {!loader ? (
          <PDFExport ref={contentRef} fileName="Receipt">
            <Box>
              <Grid container spacing={0}>
                <Grid item md={3.5}>
                  <Box
                    component={"img"}
                    src={Images.logo}
                    sx={{ width: "100%", alignItems: "center" }}
                  />
                </Grid>
                <Grid item md={8.5}>
                  <CardMedia image={Images.invoiceHeader} sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{ py: 3, textAlign: "center", color: Colors.white }}
                    >
                      Galaxy Used Cars Tr. LLC
                    </Typography>
                  </CardMedia>
                  <Grid
                    container
                    spacing={1.5}
                    alignItems={"center"}
                    justifyContent={"space-evenly"}
                  >
                    <Grid item md={4}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <InvoicePhone />
                        <Typography
                          variant="body1"
                          sx={{
                            color: Colors.smokeyGrey,
                            fontFamily: FontFamily.openSans,
                          }}
                        >
                          +971 6 510 2000
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item md={6}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <InvoiceMail />
                        <Typography
                          variant="body1"
                          sx={{
                            color: Colors.smokeyGrey,
                            fontFamily: FontFamily.openSans,
                          }}
                        >
                          info@galaxyshipping.com
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item md={4}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <InvoiceGlobal />
                        <Typography
                          variant="body1"
                          sx={{
                            color: Colors.smokeyGrey,
                            fontFamily: FontFamily.openSans,
                          }}
                        >
                          https://galaxyshipping.com
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item md={6}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <InvoiceLocation />
                        <Typography
                          variant="body1"
                          sx={{
                            color: Colors.smokeyGrey,
                            fontFamily: FontFamily.openSans,
                          }}
                        >
                          Ind Area#4 P.O Box 83126, Sharjah , UAE
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Box
                sx={{
                  my: 5,
                  position: "relative",
                  bgcolor: Colors.bluishCyan,
                  width: 1,
                  height: "12px",
                }}
              >
                <Typography
                  component={"span"}
                  variant="h2"
                  sx={{
                    color: Colors.charcoalGrey,
                    bgcolor: Colors.white,
                    p: 2,
                    letterSpacing: "3px",
                    position: "absolute",
                    right: "90px",
                    top: "-40px",
                  }}
                >
                  VEHICLE RECEIPT
                </Typography>
              </Box>
              <Grid container spacing={0} justifyContent={"space-between"} display={"flex"} flexDirection={"row"}>
                <Grid item md={5.5}>
                  <Box sx={{ ml: 4 }}>
                    <Grid container spacing={0.5}>
                      <Grid item md={12}>
                        <Typography
                          variant="h4"
                          className={classes.text}
                          sx={{ mb: 1 }}
                        >
                          Receipt To:
                        </Typography>
                      </Grid>
                      <Grid item md={5}>
                        <Typography variant="body1" className={classes.text}>
                          Customer ID:
                        </Typography>
                      </Grid>
                      <Grid item md={6}>
                        <Typography
                          noWrap
                          variant="body1"
                          className={classes.text}
                        >
                          {customerDetails?.id || "-"}
                        </Typography>
                      </Grid>
                      <Grid item md={5}>
                        <Typography variant="body1" style={{ fontWeight: 'bold' }} className={classes.text}>
                          Customer Name:
                        </Typography>
                      </Grid>
                      <Grid item md={6}>
                        <Typography variant="body1" style={{ fontWeight: 'bold' }} className={classes.text}>
                          {customerDetails?.name || "-"}
                        </Typography>
                      </Grid>
                      <Grid item md={5}>
                        <Typography variant="body1" className={classes.text}>
                          Phone:
                        </Typography>
                      </Grid>
                      <Grid item md={6}>
                        <Typography variant="body1" className={classes.text}>
                          {customerDetails?.uae_phone ?? "-"}
                        </Typography>
                      </Grid>
                      <Grid item md={5}>
                        <Typography variant="body1" className={classes.text}>
                          Email:
                        </Typography>
                      </Grid>
                      <Grid item md={6}>
                        <Typography
                          variant="body1"
                          className={classes.text}
                          sx={{
                            wordBreak: "break-word",  
                            whiteSpace: "normal",     
                            overflowWrap: "anywhere", 
                          }}
                        >
                          {customerDetails?.email ?? "-"}
                        </Typography>
                      </Grid>


                      {/* <Grid item md={5} alignItems="center">
                        <Typography
                          variant="body1" style={{ fontWeight: 'bold' }} className={classes.text}

                        >
                          Payment Mode:
                        </Typography>
                      </Grid>

                      <Grid item md={6}>
                        <Typography
                          variant="body1" style={{ fontWeight: 'bold' }} className={classes.text}

                        >
                          {paymentReceiptDetail?.payment_medium?.toUpperCase()}
                        </Typography>
                      </Grid> */}

                    </Grid>
                  </Box>
                </Grid>
                <Grid container spacing={0} item
                  xs={6}
                  sm={6}
                  md={6}
                  sx={{ border: "solid", borderWidth: 0.5, borderColor: "rgba(0,0,0,0.6" }}
                >
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    className={classes.tableCell}
                  >
                    <Typography variant="body1" className={classes.text}>
                      Created By:
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    className={classes.tableCell}
                  >
                    <Typography variant="body1" className={classes.text}>
                      {ExportVehicleDetails?.[0]?.creator?.name}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    className={classes.tableCell}
                  >
                    <Typography variant="body1" className={classes.text}>
                      Customize Date:
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    className={classes.tableCell}
                  >
                    <Typography variant="body1" className={classes.text}>
                      {moment(ExportVehicleDetails?.[0]?.payment_date).format('D-M-YYYY')}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    className={classes.tableCell}
                  >
                    <Typography variant="body1" className={classes.text}>
                      Processing Date:
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    className={classes.tableCell}
                  >
                    <Typography variant="body1" className={classes.text}>
                      {moment(ExportVehicleDetails?.[0]?.created_at).format('D-M-YYYY')}
                    </Typography>
                  </Grid>
                  {/* <Grid
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    className={classes.tableCell}
                  >
                    <Typography variant="body1" className={classes.text}>
                      GVR.NO:
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    className={classes.tableCell}
                  >
                    <Typography variant="body1" className={classes.text}>
                      GVR-{paymentReceiptDetail?.details[0]?.invoice_id}
                    </Typography>
                  </Grid> */}

                </Grid>
              </Grid>
              <Grid container spacing={0} justifyContent={"space-between"}>
                <Grid item md={12}>
                  <Box
                    className={classes.headingBg}
                    sx={{ bgcolor: Colors.primary }}
                  >
                    <Typography variant="h4" className={classes.heading}>
                      PAYMENT
                    </Typography>
                  </Box>
                  <Box sx={{ mr: 3, mx: 2 }}>
                    {ExportVehicleDetails ? (
                      <>
                        {/* Header Section */}
                        <Grid
                          container
                          spacing={0}
                          columns={12}
                          justifyContent={"flex-end"}
                          sx={{
                            border: "0.5px solid rgba(0,0,0,0.6)",
                            backgroundColor: "#f0f0f0",
                          }}
                        >

                          <Grid item md={2}>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                textAlign: "center",
                                fontFamily: FontFamily.openSans,
                                fontSize: 14,
                              }}
                            >
                              GVI.No
                            </Typography>
                          </Grid>

                          <Grid item md={2}>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                fontFamily: FontFamily.openSans,
                                fontSize: 14,
                                textAlign: "center",
                              }}
                            >
                              VIN
                            </Typography>
                          </Grid>

                          <Grid item md={2}>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                fontFamily: FontFamily.openSans,
                                fontSize: 14,
                                textAlign: "center",
                              }}
                            >
                              Make
                            </Typography>
                          </Grid>


                          <Grid item md={2}>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                fontFamily: FontFamily.openSans,
                                fontSize: 14,
                                textAlign: "center",
                              }}
                            >
                              Model
                            </Typography>
                          </Grid>


                          <Grid item md={2}>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                fontFamily: FontFamily.openSans,
                                fontSize: 14,
                                textAlign: "center",
                              }}
                            >
                              Color
                            </Typography>
                          </Grid>



                          <Grid item md={1}>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                textAlign: "center",
                                fontFamily: FontFamily.openSans,
                                fontSize: 14,
                              }}
                            >
                              USD
                            </Typography>
                          </Grid>

                          <Grid item md={1}>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                textAlign: "center",
                                fontFamily: FontFamily.openSans,
                                fontSize: 14,
                              }}
                            >
                              AED
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid sx={{
                          border: "0.5px solid rgba(0,0,0,0.6)",
                        }} container spacing={0} columns={12} justifyContent={"flex-end"} textAlign={"center"}>
                          {
                            ExportVehicleDetails.map((item, index) => (
                              <Fragment key={index}>
                                <Grid item md={2} className={classes.tableCell}>
                                  <Typography variant="body2" className={classes.text}>
                                    GVI-{item?.ev_id || "-"}
                                  </Typography>
                                </Grid>

                                <Grid item md={2} className={classes.tableCell}>
                                  <Typography variant="body2" className={classes.text}>
                                    {item?.vin ?? "-"}
                                  </Typography>
                                </Grid>

                                <Grid item md={2} className={classes.tableCell}>
                                  <Typography variant="body2" className={classes.text}>
                                    {item?.veh_makes ?? "-"}
                                  </Typography>
                                </Grid>



                                <Grid item md={2} className={classes.tableCell}>
                                  <Typography variant="body2" className={classes.text}>
                                    {item?.veh_models ?? "-"}
                                  </Typography>
                                </Grid>


                                <Grid item md={2} className={classes.tableCell}>
                                  <Typography variant="body2" className={classes.text}>
                                    {item?.color ?? "-"}
                                  </Typography>
                                </Grid>


                                <Grid item md={1} className={classes.tableCell}>
                                  <Typography variant="body2" className={classes.text}>
                                    {CommaSeparator(parseFloat(item?.final_price)?.toFixed(2))}
                                  </Typography>
                                </Grid>

                                <Grid item md={1} className={classes.tableCell}>
                                  <Typography variant="body2" className={classes.text}>
                                    {CommaSeparator(parseFloat(item?.final_price * item?.ex_rate)?.toFixed(2))}
                                  </Typography>
                                </Grid>

                              </Fragment>



                            ))
                          }


                        </Grid>
                      </>
                    ) : (
                      <Typography
                        variant="subtitle1"
                        sx={{
                          textAlign: "center",
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        No Data
                      </Typography>
                    )}
                  </Box>

                </Grid>

              </Grid>
              <Box sx={{ mx: 3.5 }}>
                <Grid
                  className={classes.headingBg}
                  sx={{ bgcolor: Colors.bluishCyan, }}
                  container spacing={0} xs={12} sm={6} md={6}
                  textAlign={"center"}
                  justifyContent={"center"}
                >
                  <Typography variant="h4" className={classes.heading}>
                    PAYMENT HISTORY
                  </Typography>
                </Grid>
                <Box sx={{ mr: 3 }}>
                  {/* {ExportVehicleDetails?.details?.length > 0 ? ( */}
                  <Grid container spacing={0} xs={12} sm={6} md={6} justifyContent={"flex-end"}>
                    <Grid item xs={3} sm={3} md={3}>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontFamily: FontFamily.openSans, textAlign: "center" }}
                      >
                        Paid on
                      </Typography>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          textAlign: "center",
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        Payment Mode
                      </Typography>

                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          textAlign: "center",
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        USD

                      </Typography>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          textAlign: "center",
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        AED
                      </Typography>
                    </Grid>

                    <Fragment>
                      <Grid
                        item
                        xs={3}
                        sm={3}
                        md={3}
                        className={classes.tableCell}
                      >
                        <Typography
                          variant="body1"
                          className={classes.text}
                        >
                          {ExportVehicleDetails?.[0]?.payment_date
                            ? moment(ExportVehicleDetails?.[0]?.payment_date).format("D-M-YY")
                            : "-"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={3}
                        sm={3}
                        md={3}
                        className={classes.tableCell}
                      >
                        <Typography
                          variant="body1"
                          className={classes.text}
                          sx={{ textAlign: "center" }}
                        >
                          {ExportVehicleDetails?.[0]?.payment_medium}

                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={3}
                        sm={3}
                        md={3}
                        className={classes.tableCell}
                      >
                        <Typography
                          variant="body1"
                          className={classes.text}
                          sx={{ textAlign: "right" }}
                        >
                          {CommaSeparator(parseFloat(totalAmount).toFixed(2))}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={3}
                        sm={3}
                        md={3}
                        className={classes.tableCell}
                      >
                        <Typography
                          variant="body1"
                          className={classes.text}
                          sx={{ textAlign: "right" }}
                        >
                          {CommaSeparator(parseFloat(totalAmount * 3.675)?.toFixed(2))}
                        </Typography>
                      </Grid>
                    </Fragment>
                  </Grid>
                  {/* ) : (
                    <Typography
                      variant="subtitle1"
                      sx={{
                        textAlign: "center",
                        fontFamily: FontFamily.openSans,
                      }}
                    >
                      No Payment History
                    </Typography>
                  )} */}
                </Box>
              </Box>
              <Grid container spacing={0} justifyContent={"space-between"}>
                {/* <Grid item md={9.5}>
                  <Box sx={{ pl: 4, pr: 3, mb: 3, mt: 4 }}>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      PLEASE READ CAREFULLY BELOW TERM & CONDITION:
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.text}
                      sx={{ mb: 1 }}
                    >
                      1 - I've clearly informed and the make the understand all
                      the vehicle information, amount, charges and rates.
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.text}
                      sx={{ mb: 1 }}
                    >
                      2 - Kindly pay the due amount within 3 business days from
                      the purchase date to avoid the Late Payment and Storages
                      that will be charged once vehicle arrived to final
                      destination (Further, If there are some special
                      annousment/memo ignore this and follow that)
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.text}
                      sx={{ mb: 1 }}
                    >
                      3 - If vehicle got relisted, the relist charges customer
                      has to pay within 3 days otherwise 15% Penalty will
                      applied after 3 days as issued memo on 9/Jun/2022.
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.text}
                      sx={{ mb: 1 }}
                    >
                      4 - Galaxy Customer care department will inform you about
                      the latest updates about rates and charges through
                      WhatsApp and emails.
                    </Typography>
                  </Box>
                </Grid>
                <Grid item md={2}>
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <QRCodeCanvas
                      value={
                        window.location.origin +
                        `/payment-receipt-preview/${btoa(
                          "paymentreceipt-" + id
                        )}`
                      }
                    />
                  </Box>
                </Grid> */}
              </Grid>
              <Box sx={{ pl: 4, pr: 3, py: 1, bgcolor: Colors.primary, marginTop: '10px' }}>
                <Typography
                  variant="caption"
                  sx={{
                    color: Colors.white,
                    fontFamily: FontFamily.openSans,
                  }}
                >
                  Customer Care Contact: Mohammed Rafi 00971 54 583 6030 or Mr Hamdan 00974 54 583 6022.
                  For complaints, Please WhatsApp @ +4917663203237
                </Typography>
                {/* <Typography
                  variant="caption"
                  sx={{
                    color: Colors.white,
                    fontFamily: FontFamily.openSans,
                  }}
                >
                  Ravin abdul kareem - +971528293801 (Kurdish , Arabic &
                  English) Magsat Gylyjov - +97158666403 (Turken , Russian &
                  English)
                </Typography> */}
              </Box>
            </Box>
          </PDFExport>
        ) : (
          <Box sx={{ textAlign: "center", py: 3 }}>
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Container>
  );
}

export default ExportPaymentsRecipt;
